import loaded from './reducers/loaded';
import ui from './reducers/ui';

export default {
  loaded,
  ui,
};
